<template>
	<div class="page--404">
        <h1>Oops…<br/>404 – Page not found!</h1>
        <p>Oh dear, looks like you’ve hit a little turbulence. It seems the page you’re looking for isn’t here. To get you back on the right path, please check you’ve correctly typed the URL, or use the search function above to find what you’re looking for.</p>
        <btn :href="'https://library.loxone.com'" :text="'Back to Loxone Library'" />
	</div>
</template>

<script>
    import Btn from '@/components/Button.vue';
    export default {
        components: {
            Btn
        },
    }
</script>

<style scoped lang="scss">
    .page--404{
        max-width: 600px;
        margin: 0 auto;
        text-align: center;
        margin-top: 60px;
    }

    .lulz{
        margin-top: 40px;
    }
</style>
